export const privacyPolicy = `# Политика обработки персональных данных

**Сайт:** kolodec-septiki.ru  
**Дата вступления в силу:** 7 мая 2026 г.  
**Версия:** 1.0

---

## 1. Общие положения

1.1. Настоящая Политика обработки персональных данных (далее — «Политика») разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных пользователей сайта kolodec-septiki.ru.

1.2. Оператор персональных данных:

- **Наименование:** ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ
- **ИНН:** 752405626175
- **ОГРНИП:** 325508100039277
- **Юридический адрес:** 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1
- **Сайт:** https://kolodec-septiki.ru
- **Электронная почта:** info@kolodec-septiki.ru

1.3. Оператор осуществляет деятельность в сфере: **строительство колодцев и монтаж септиков**.

1.4. Политика распространяется на все персональные данные, обрабатываемые Оператором с использованием средств автоматизации и без таковых.

---

## 2. Правовые основания обработки

Обработка персональных данных осуществляется на следующих правовых основаниях:

- **Согласие субъекта персональных данных** (ст. 6, ч. 1, п. 1 и ст. 9 Закона № 152-ФЗ) — при заполнении форм обратной связи и заявок;
- **Исполнение договора** (ст. 6, ч. 1, п. 5 Закона № 152-ФЗ) — при выполнении работ и оказании услуг;
- **Законные интересы Оператора** (ст. 6, ч. 1, п. 7 Закона № 152-ФЗ) — для защиты прав и законных интересов.

---

## 3. Цели обработки персональных данных

| Цель обработки | Категория данных |
|---|---|
| Обработка и исполнение заявок на услуги | Имя, телефон, электронная почта, адрес объекта |
| Расчёт стоимости услуг, составление смет | Имя, телефон, адрес объекта |
| Связь с клиентом по вопросам заказа | Имя, телефон, электронная почта |
| Направление информационных и коммерческих сообщений (при наличии согласия) | Имя, телефон, электронная почта |
| Улучшение качества работы сайта (аналитика) | Технические данные, cookies |
| Исполнение требований законодательства РФ | Данные, предусмотренные законом |

---

## 4. Перечень обрабатываемых персональных данных

Оператор обрабатывает следующие категории персональных данных:

**Данные, предоставляемые субъектом:**
- Фамилия, имя, отчество;
- Номер телефона;
- Адрес электронной почты;
- Адрес объекта (для выезда специалиста);
- Содержание обращения / комментарии.

**Технические данные (собираемые автоматически):**
- IP-адрес;
- Данные файлов cookie;
- Идентификатор браузера и устройства;
- Данные о посещённых страницах и действиях на сайте.

Оператор **не обрабатывает** специальные категории персональных данных (расовая принадлежность, политические взгляды, состояние здоровья, биометрические данные и т.п.).

---

## 5. Способы и сроки обработки

5.1. Обработка персональных данных осуществляется:
- с использованием средств автоматизации (CRM-система, электронная почта, аналитические сервисы);
- без использования средств автоматизации (бумажные документы, рабочая документация).

5.2. Сроки хранения:

| Категория данных | Срок хранения |
|---|---|
| Данные из форм обратной связи (без договора) | 3 года с момента получения |
| Данные, связанные с исполнением договора | 5 лет с момента окончания договора |
| Данные для рекламных рассылок | До отзыва согласия субъектом |
| Технические данные (cookies, логи) | Не более 12 месяцев |

По истечении срока хранения данные уничтожаются или обезличиваются.

---

## 6. Передача персональных данных третьим лицам

6.1. Персональные данные могут передаваться следующим категориям получателей:

- **Сервисы аналитики:** Яндекс.Метрика (ООО «Яндекс», Россия) — для анализа посещаемости сайта;
- **Сервисы коммуникаций:** сервисы SMS и email-рассылок — при наличии согласия субъекта;
- **Государственные органы** — в случаях, предусмотренных законодательством РФ.

6.2. Оператор **не продаёт** и **не передаёт** персональные данные третьим лицам в коммерческих целях без согласия субъекта.

6.3. При трансграничной передаче данных Оператор обеспечивает соответствие требованиям ст. 12 Закона № 152-ФЗ и уведомляет Роскомнадзор в установленном порядке.

---

## 7. Права субъектов персональных данных

Субъект персональных данных вправе:

- **Получить информацию** о составе и способах обработки своих данных;
- **Потребовать уточнения, блокирования или уничтожения** персональных данных в случае, если они неполные, устаревшие, неточные или незаконно обрабатываются;
- **Отозвать согласие** на обработку персональных данных в любое время;
- **Обжаловать** действия/бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор) или в суд.

Для реализации прав субъект может направить письменное обращение по адресу: 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1 или по электронной почте: info@kolodec-septiki.ru

Срок ответа — **30 календарных дней** с даты получения обращения.

---

## 8. Меры по защите персональных данных

Оператор принимает следующие меры защиты:

- Ограничение доступа сотрудников к персональным данным по принципу необходимости;
- Использование защищённых соединений (HTTPS) при передаче данных;
- Регулярное обновление программного обеспечения;
- Антивирусная защита и резервное копирование данных.

---

## 9. Файлы cookie

9.1. Сайт kolodec-septiki.ru использует файлы cookie. Подробная информация — в **Политике использования cookie** по адресу: https://kolodec-septiki.ru/cookie-policy

9.2. Пользователь вправе отключить cookie в настройках браузера, однако это может ограничить функциональность сайта.

---

## 10. Порядок обработки запросов

10.1. Оператор обязуется рассматривать обращения субъектов персональных данных и отвечать на них в течение 30 дней.

10.2. Запросы направляются:
- Почтой: 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1
- Email: info@kolodec-septiki.ru

---

## 11. Изменение Политики

11.1. Оператор вправе вносить изменения в настоящую Политику без предварительного уведомления пользователей.

11.2. Актуальная версия Политики всегда доступна на сайте по адресу: https://kolodec-septiki.ru/privacy-policy

11.3. Продолжение использования сайта после изменений означает принятие обновлённой Политики.

---

## 12. Контактная информация

**ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ СЕРЕБРЕННИКОВ РОМАН АЛЕКСАНДРОВИЧ**  
ИНН: 752405626175 | ОГРНИП: 325508100039277  
Адрес: 143512, Россия, Московская обл., г. Истра, д. Адуево, тер. ДНП Дольче Вита, д. 322/1  
Email: info@kolodec-septiki.ru  
Сайт: https://kolodec-septiki.ru
`;
